import type { ProjectReportsGatewayPort } from "@/application/project-reports/ports/ProjectReportsGatewayPort";
import type { CreateProjectReportDTO, ProjectReportDTO } from "@/application/project-reports/dtos/ProjectReportDTO";
import { ProjectReport } from "@/domain/project-reports/entities/ProjectReport";

export class CreateProjectReportUseCase {
  constructor(private readonly gateway: ProjectReportsGatewayPort) {}

  async execute(projectId: string, data: CreateProjectReportDTO): Promise<ProjectReportDTO> {
    if (!projectId || projectId.trim().length === 0) {
      throw new Error("Project ID is required");
    }

    const entity = ProjectReport.create({
      projectId,
      promptsIds: data.promptsIds,
      recordsIds: data.recordsIds,
      category: data.category ?? "Custom",
      title: data.title.trim(),
      context: data.context ?? null,
      contextExpand: data.contextExpand ?? null,
      status: data.status ?? "Saved",
      content: data.content ?? null,
      isPublic: data.isPublic ?? false,
      isArchived: data.isArchived ?? false,
      isDeleted: false,
    });

    const payload: CreateProjectReportDTO = {
      promptsIds: entity.promptsIds,
      recordsIds: entity.recordsIds,
      category: entity.toObject().category,
      title: entity.title,
      context: entity.toObject().context,
      contextExpand: entity.toObject().contextExpand,
      status: entity.status,
      content: entity.toObject().content,
      isPublic: entity.toObject().isPublic,
      isArchived: entity.toObject().isArchived,
      // Preserve presetId and reportLanguage from input data
      presetId: data.presetId ?? null,
      reportLanguage: data.reportLanguage ?? null,
    };

    return this.gateway.create(projectId, payload);
  }
}
